import React from 'react';
import { Box, Tab, Tabs, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CreditCard as GatewayIcon,
  PointOfSale as PosIcon,
  Assessment as ReportIcon,
  Summarize as SummaryIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const PaymentTabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on current path
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/gateway-config')) return 0;
    if (path.includes('/pos-config')) return 1;
    if (path.includes('/gateway-reports')) return 2;
    if (path.includes('/pos-reports')) return 3;
    return 0; // Default
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/system-settings/payments/gateway-config');
        break;
      case 1:
        navigate('/system-settings/payments/pos-config');
        break;
      case 2:
        navigate('/system-settings/payments/gateway-reports');
        break;
      case 3:
        navigate('/system-settings/payments/pos-reports');
        break;
      default:
        break;
    }
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', p: 2 }}>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/system-settings')}
            >
              Back
            </Button>
          </Box>
      <Tabs
        value={getActiveTab()}
        onChange={handleChange}
        aria-label="payment settings tabs"
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab icon={<GatewayIcon />} label="Payment Gateway" />
        <Tab icon={<PosIcon />} label="POS Settings" />
        <Tab icon={<ReportIcon />} label="Gateway Reports" />
        <Tab icon={<SummaryIcon />} label="POS Reports" />
      </Tabs>
    </Box>
  );
};

export default PaymentTabs;
